<template>
  <v-card>
    <v-card-title>Contact Me</v-card-title>
    <v-row>
      <v-col>
        <v-icon class="mx-4" color="green">mdi-map-marker-radius-outline</v-icon>Istanbul | Turkey
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-icon class="mx-4" color="red">mdi-email-outline</v-icon>osmntamer[at]gmail.com
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'Contact',
}
</script>

<style>

</style>